import { useRef, useState } from "react"
import Config from "../../config"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import GridComponent from "../shared/grid"
import { useNavigate } from "react-router-dom"
import setToast from "../../helpers/toaster.helper"
import * as selector from "../../selectors/selectors"
import { UserService } from "../../services/UserService"
import { ToasterType } from "../shared/toaster/toaster.model"
import { PlanMetrics } from '../../models/plan-metrics.model'
import { UtilityService } from "../../services/UtilityService"
import ButtonComponent from "../shared/button/button.component"
import { buttonLabels, emptyLabels, ToasterTexts } from "../shared/constants"
import { SecureFileService } from "../../services/SecureFileService"
import { ColDef, GridApi, ValueGetterParams } from "ag-grid-community"
import { DisplayMediaIcon } from "../secure-file/display-media.component"
import AddAccessListTextComponent from "../secure-file/add-access-list.component"
import { DocumentPermissions, FaceAuthenticationModel, FaceRegistrationInviteLinkStatus, SecureFileModel, SecureFileStatusModel, ValidityType } from "../../models/secure-file"
import { Autocomplete, DialogActions, DialogContent, MenuItem, Select, TextField, Tooltip } from "@mui/material"
import { CancelIcon, EmailShareIcon, FaceShareIcon, UploadFileIcon, NotRegisteredIcon, UpgradeFeatureIcon, ReadOnlyIcon, SecureFileDownloadIcon } from "../../icon"
import { AppRoutes } from "../routes/route.path"
import Avatar from "../shared/avatar.component"
import { HmacSignatureUtilities } from "../../services/hmac-encryption-decryption"
import { LoadSecureFiles } from "../../actions"
import { useDispatch } from "react-redux"

interface Props {
    CloseSecurefilePopover?: (url?: string) => void
    OnSendInvite?: () => void
    FaceRegistrationStatus?: number;
    Limit: number;
    ContactNumbers: string[];
}

const SecureFilePopoverComponent = (props: Props) => {
    let id = { "user_id": UserService.getCurrentUserId() }
    
    const ValidityPeriod = [
        { Name: "One Day", Value: ValidityType.ONE_DAY },
        { Name: "One Week", Value: ValidityType.ONE_WEEK },
        { Name: "One Month", Value: ValidityType.ONE_MONTH }
    ]
    let documentPermissions = [
        { Name: "Read Only", Value: DocumentPermissions.READONLY, Icon: <ReadOnlyIcon /> },
        { Name: "Download", Value: DocumentPermissions.DOWNLOAD, Icon: <SecureFileDownloadIcon /> }
    ]
    const AllowedExtensions = [
        "audio/",
        "video/",
        "image/",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        "text/plain"
    ];

    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const SecureFiles: SecureFileModel[] = useSelector(selector.secureFiles)
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics)
    const FaceAuthenticationFiles: FaceAuthenticationModel[] = useSelector(selector.faceAuthenticatonFiles);

    const [gridApi, setGridApi] = useState<GridApi>(null)
    const [columnApi, setcolumnApi] = useState<any>(null)
    const [fileUpload, setFileupload] = useState<any>("")
    const [isValidityPeriod, setisValidityPeriod] = useState(ValidityType.ONE_DAY)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const [addedAccesslist, setAddedAccessList] = useState<any>()
    const [selectedAuth, setSelectedAuth] = useState<"face" | "email">("face")
    const [selectedTab, setSelectedTab] = useState<"upload" | "library">((props.Limit === 0) ? "library" : "upload")
    const [faceRegistrationStatus, setFaceRegistrationStatus] = useState<number>(props.FaceRegistrationStatus)
    const [documnetPermisson, setDocumnetPermisson] = useState<number>(DocumentPermissions.READONLY)
    const [fileUploadError, setFileUploadError] = useState<string>("")


    const handleSendInvite = () => {
        setIsLoading(true)
        props.OnSendInvite?.()
    }

    const closeCustomField = () => {
        props.CloseSecurefilePopover()
    }

    const handlValidityPeriod = (e: any, value: any) => {
        if (value) {
            setisValidityPeriod(value?.Value)
        }
    }

    const FileLibraryEmailColumnDefs: ColDef[] = [
        {
            field: "FileName",
            headerName: "File Name",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.FileName
            },
            cellClass: "c-pointer",
            cellRenderer: (params) => {
                let name = params.data.FileName.substring(0, params.data.FileName.lastIndexOf("."))
                return <div className='d-flex align-center'>
                    <DisplayMediaIcon FileName={params.data.FileName} />
                    <span className='ml-1'>{name}</span>
                </div>
            }
        },
        {
            field: "SharedEmails",
            headerName: "Who has Email access",
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.SharedEmails
            },
            cellClass: "c-pointer",
            cellRenderer: (params) => {
                const emails = params.value;
                return (
                    <div className="d-flex align-center">
                        {emails?.map((email, index) => {
                            const initials = email.substring(0, 2).toUpperCase();
                            return (
                                <Tooltip key={index} title={email} placement="top">
                                    <span className='c-pointer mrn-1'>
                                        <Avatar Name={initials} Size={28} />
                                    </span>
                                </Tooltip>
                            )
                        })}
                    </div>
                )
            }
        }
    ]

    const FileLibraryFaceColumnDefs: ColDef[] = [
        {
            field: "FileName",
            headerName: "File Name",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.FileName
            },
            cellClass: "c-pointer",
            cellRenderer: (params) => {
                let name = params.data.FileName.substring(0, params.data.FileName.lastIndexOf("."))
                return <div className='d-flex align-center'>
                    <DisplayMediaIcon FileName={params.data.FileName} />
                    <span className='ml-1'>{name}</span>
                </div>
            }
        },
        {
            field: "SharedFaces",
            headerName: "Who has Face access",
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.SharedFaces
            },
            cellClass: "c-pointer",
            cellRenderer: (params) => {
                const faces = params.value;
                return (
                    <div className="d-flex align-center">
                        {faces?.map((face, index) => {
                            const initials = face.substring(0, 2).toUpperCase();
                            return (
                                <Tooltip key={index} title={face} placement="top">
                                    <span className='c-pointer mrn-1'>
                                        <Avatar Name={initials} Size={28} />
                                    </span>
                                </Tooltip>
                            )
                        })}
                    </div>
                )
            },
        }
    ]

    const onChange = (e) => {
        const file = e.target.files?.[0];
        if (e.target.files[0].size > 20000000) {
            setToast(ToasterTexts.FILE_SIZE_EXCEED_LIMIT.replace("<size>", "20"), ToasterType.DANGER)
        }
        else if (e.target.files) {
            setFileupload(e.target.files[0])
            if (documnetPermisson === DocumentPermissions.READONLY) {
                const isValid = AllowedExtensions.some(ext => file.type.startsWith(ext));
                if (!isValid) {
                    setFileUploadError("Invalid file type. Please upload .audio .video .image .pdf .docx .txt")
                    return
                }
            }
        }
    }

    const handleCancel = () => {
        setFileupload("")
        setFileUploadError("")
        const fileInput = document.getElementById("Upload") as HTMLInputElement
        if (fileInput) fileInput.value = ""
    }

    const addAccessListHandel = (list) => {
        setAddedAccessList(list)
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setcolumnApi(params.columnApi)
    }

    const formSubmit = () => {
        let access = addedAccesslist?.map(x => UtilityService.isValidEmail(x) && x).filter(x => !!x)
        let activeFiles = SecureFiles.filter(x => x.Status === SecureFileStatusModel.Active)

        setIsLoaded(true)
        if (activeFiles?.length > 20) {
            setToast("Currently this feature is in its beta, and you are limited to having a maximum of 20 active secured files ", ToasterType.DANGER)
            setIsLoaded(false)
        }
        else {
            const getExpDays = (validity: ValidityType | null) => {
                switch (validity) {
                    case ValidityType.ONE_DAY:
                        return 1
                    case ValidityType.ONE_WEEK:
                        return 7
                    case ValidityType.ONE_MONTH:
                        return 30
                    default:
                        return 1
                }
            }
            const faceAcces = props.ContactNumbers.filter(x => FaceAuthenticationFiles.some(y => y.Status === FaceRegistrationInviteLinkStatus.Registered && y.ContactPhoneNumber === x?.replace("+", "")))

            const organizationId = UserService.getCurrentUserOrgId()
            let uploadData = new FormData()
            uploadData.append("userId", UserService.getCurrentUserId())
            uploadData.append("userName", JSON.parse(localStorage.getItem("current-user")).firstName)
            if ((selectedTab === "upload" && selectedAuth === "email")) {
                uploadData.append("sharedEmails", access ? access : []);
            }
            else (uploadData.append("sharedEmails", ""))
            uploadData.append("file", fileUpload)
            uploadData.append("redirectURL", Config.APP_FE_URL)
            uploadData.append("isReadOnly", documnetPermisson.toString())
            uploadData.append("expDays", getExpDays(isValidityPeriod).toString())
            if ((selectedTab === "upload" && selectedAuth === "face")) {
                uploadData.append("sharedFaces", faceAcces.map(x => x?.replace("+", "")).join(","))
            }
            uploadData.append("organizationId", organizationId)
            uploadData.append("phoneNumber", UserService.getUserPhoneNumber().replace("+", ""))

            SecureFileService.uploadFile(uploadData).then((res) => {
                if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                    setIsLoaded(false)
                    const fullFilePath = res.data.file
                    selectedTab === "upload" && selectedAuth === "email" ? props.CloseSecurefilePopover(res?.data?.url) : props.CloseSecurefilePopover(res?.data?.faceUrl)
                }
                
                else {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                }
                 LoadSecureFiles(dispatch, id)
            }
            ).catch((err) => {
                setIsLoaded(false)
                setToast(err?.response?.data?.error, ToasterType.DANGER)
            })
        }
    }

    const handleDocumentPermissions = (value) => {
        if (value) {
            if (value === DocumentPermissions.READONLY && !!fileUpload) {
                const isValid = AllowedExtensions.some(ext => fileUpload.type.startsWith(ext));
                if (isValid) {
                    setDocumnetPermisson(value)
                }
                else {
                    setDocumnetPermisson(value)
                    setFileUploadError("Invalid file type. Please upload .audio .video .image .pdf .docx .txt")
                }
            }
            else {
                setFileUploadError("")
                setDocumnetPermisson(value)
            }
        }
    }

    const formatFileSize = (size: number) => {
        return size < 1024 * 1024 ? `${(size / 1024).toFixed(2)} KB` : `${(size / (1024 * 1024)).toFixed(2)} MB`;
    };

    const isVaild = () => {
        let valid = addedAccesslist?.map(x => UtilityService.isValidEmail(x) && x).filter(x => !x)
        return valid?.length > 0 ? false : true
    }

    return (
        <>
            <DialogContent className={`p-1 ${IsDarkMode ? "bg-color-sidebar-bg" : ""}`}>
                <div className="d-flex justify-center align-center mb-2">
                    <div className="d-flex color-settings-heading h3-semibold">Secure file</div>
                    <CancelIcon onClick={closeCustomField} className="c-pointer ml-auto" />
                </div>
                <div>
                    <div>
                        <div className="d-flex w-p-100 ">
                            <div style={{ pointerEvents: (props.Limit === 0) ? "none" : "auto" }} onClick={() => setSelectedTab("upload")} className={`px-2 c-pointer w-p-50 h-4 d-flex justify-center align-center 
                                    ${selectedTab === "upload" ? `h4-semibold ${IsDarkMode ? "" : "color-primary-light"}` : "h4-regular color-secondary-light"}`}>
                                Upload File
                            </div>
                            <div onClick={() => setSelectedTab("library")} className={`px-2 c-pointer w-p-50 h-4 d-flex justify-center align-center 
                                    ${selectedTab === "library" ? `h4-semibold ${IsDarkMode ? "" : "color-primary-light"}` : "h4-regular color-secondary-light"}`}>
                                File Library
                            </div>
                        </div>
                        <div className={`show-conversation-animation show-conversation-border show-conversation-height bg-color-primary-light ${selectedTab === "upload" ? IsMobileDevice ? "w-22" : "w-36" : IsMobileDevice ? " ml-25 w-22" : "ml-37 w-36"}`} />
                    </div>
                    <div className={`msg-composer-secure-file-border br-2 ${selectedTab !== "library" && "pb-2"}`}>
                        <div className="d-flex justify-center align-center my-2 w-p-100 ">
                            <div className={`${IsMobileDevice ? "ml-1" : "ml-2"} d-flex align-center justify-center br-1 msg-composer-secure-file-border c-pointer w-p-50 h-5 
                                ${selectedAuth === "face" ? `${IsDarkMode ? "bg-color-side-bar-active-bg" : "bg-color-grid"} h5-semibold` : "h5-regular color-secondary-light"}`} onClick={() => setSelectedAuth("face")}>
                                <FaceShareIcon className="mr-1" />
                                Face Authentication
                            </div>
                            <div className={`${IsMobileDevice ? "mr-1" : "mr-2"} d-flex align-center justify-center br-1 msg-composer-secure-file-border c-pointer w-p-50 h-5 
                                ${selectedAuth === "email" ? `${IsDarkMode ? "bg-color-side-bar-active-bg" : "bg-color-grid"} h5-semibold` : "h5-regular color-secondary-light"}`} onClick={() => setSelectedAuth("email")}>
                                <EmailShareIcon className="mr-1" />
                                Email Authentication
                            </div>
                        </div>
                        {selectedTab === "upload" && selectedAuth === "face" && !PlanMetrics?.HasAccessToFaceVault && (
                            <div className="d-flex justify-center align-center flex-direction mt-2">
                                <div className="d-flex justify-center align-center"><UpgradeFeatureIcon className="w-p-65 h-24" /></div>
                                <div className="h4-semibold mt-1 color-settings-heading">Upgrade your plan for more features.</div>
                                <div className='d-flex mt-1'>
                                    <div className='h5-regular t-align-center color-settings-heading'>or connect us for</div>&nbsp;&nbsp;
                                    <div className='h5-regular t-align-center color-login-link c-pointer'>
                                        <Link tabIndex={5}
                                            data-arrow-index={10}
                                            data-up-arrow-index={6}
                                            data-down-arrow-index={7}
                                            data-left-arrow-index={2}
                                            data-right-arrow-index={10}
                                            to={null}>
                                            Customer support
                                        </Link>
                                    </div>
                                </div>
                                <ButtonComponent OnClick={() => navigate(AppRoutes.PLANS)} ButtonLabel={buttonLabels.UPGRADE_NOW} ClassName={"mt-2"} Variant={"primary-btn-small"} />
                            </div>
                        )}
                        {
                            props.Limit === 1 && PlanMetrics?.HasAccessToFaceVault && selectedTab === "upload" && selectedAuth === "face" && (faceRegistrationStatus === FaceRegistrationInviteLinkStatus.NotRegistered || faceRegistrationStatus === FaceRegistrationInviteLinkStatus.Expired) && (
                                <div className="d-flex justify-center align-center flex-direction mt-2">
                                    <div className="d-flex justify-center align-center"><NotRegisteredIcon className="w-p-65 h-24" /></div>
                                    <div className="h4-semibold mt-1 color-settings-heading">This user has not registered their face.</div>
                                    <div className="h5-regular mt-1 color-settings-heading">Please register the user to share file.</div>
                                    <ButtonComponent OnClick={handleSendInvite} Loading={isLoading} ButtonLabel={buttonLabels.SEND_INVITE} ClassName={"mt-2"} Variant={"primary-btn-small"} />
                                </div>
                            )
                        }
                        {
                            PlanMetrics?.HasAccessToFaceVault && selectedTab === "upload" && selectedAuth === "face" && (props.Limit === 1 ? (faceRegistrationStatus === FaceRegistrationInviteLinkStatus.Registered || faceRegistrationStatus === FaceRegistrationInviteLinkStatus.Pending) : true) && (
                                <div className={`${IsMobileDevice ? "mx-1" : "mx-2"}`}>
                                    <div className="d-flex w-p-100 align-center justify-between mx-auto">
                                        <div className={`${IsMobileDevice ? "w-p-25" : "w-p-30"} my-1`}>
                                            <div className="h5-semibold">File Name</div>
                                            <TextField
                                                size='small'
                                                fullWidth
                                                variant="outlined"
                                                className='mt-1'
                                                disabled
                                                placeholder='Default File name'
                                                value={fileUpload?.name || ""}
                                                InputProps={{ classes: { input: `h4-regular` } }}
                                            />
                                        </div>
                                        <div className={`${IsMobileDevice ? "w-p-35" : "w-p-32"} my-1`}>
                                            <div className="h5-semibold mb-1">Validity Period</div>
                                            <Autocomplete
                                                size="small"
                                                classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                                options={ValidityPeriod}
                                                getOptionLabel={(option) => option?.Name}
                                                onChange={handlValidityPeriod}
                                                value={ValidityPeriod.find(x => x.Value === Number(isValidityPeriod))}
                                                renderOption={(defaultProps, option, { selected }) => (
                                                    <li
                                                        {...defaultProps}
                                                        className={`${defaultProps.className} c-pointer h4-regular color-primary-dark p-1 ml-1 d-flex justify-between ${selected ? 'Mui-focused' : ''}`}
                                                    >
                                                        {option?.Name}
                                                    </li>
                                                )}
                                                renderInput={(params) => <TextField {...params} name="validity period" placeholder="select" required variant="outlined" />}
                                            />
                                        </div>
                                        <div className="w-p-33">
                                            <div className="h5-semibold mb-1">{`${IsMobileDevice ? "" : "Document"} Permissions`}</div>
                                            <Select
                                                size='small'
                                                value={documnetPermisson || ""}
                                                onChange={(event) => handleDocumentPermissions(event.target.value)}
                                                renderValue={(selected) => {
                                                    const selectedOption = documentPermissions.find((x) => x.Value === selected);
                                                    return (
                                                        <div className="d-flex o-hidden" >
                                                            <div className="mr-1 d-flex align-center">{selectedOption.Icon}</div>
                                                            <span className="o-hidden t-overflow-ellipsis">{selectedOption.Name}</span>
                                                        </div>
                                                    )
                                                }}
                                                sx={{
                                                    width: "100%",
                                                    "& .MuiSelect-select": {
                                                        overflow: "hidden"
                                                    }
                                                }}
                                            >
                                                {documentPermissions.map((option) => (
                                                    <MenuItem key={option.Value} value={option.Value}>
                                                        <div className="d-flex">
                                                            <div className="mr-1 d-flex align-center">{option.Icon}</div>
                                                            <span>{option.Name}</span>
                                                        </div>
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className={`${IsDarkMode ? "bg-color-primary-background" : "bg-color-conv-hist-bg"}  h-26 d-flex align-center justify-center br-2 mt-1`}>
                                        <div
                                            onClick={() => {
                                                if (!fileUpload) {
                                                    fileInputRef.current?.click();
                                                }
                                            }}
                                            className={`d-flex  flex-direction align-center justify-center ${!fileUpload && "c-pointer"} ${(!!fileUpload && !fileUploadError) ? '' : ` m-2 h-p-80 ${!!fileUploadError ? "b-around-danger" : "import-contacts-border"}`}  br-2 w-p-100 `}>
                                            {!fileUpload &&
                                                <>
                                                    <UploadFileIcon />
                                                    <input
                                                        id="Upload"
                                                        type="file"
                                                        name='fileupload'
                                                        className="p-absolute t-0 l-0 opacity-0 c-pointer"
                                                        ref={fileInputRef}
                                                        onChange={onChange}
                                                        accept={documnetPermisson === DocumentPermissions.READONLY ? "audio/*,video/*,image/*,.pdf,.docx,.txt" : ""}
                                                    />
                                                    <span className={`h5-regular color-disabled-btn d-flex align-center justify-center`}>
                                                        {documnetPermisson === DocumentPermissions.READONLY ? "Upload your file .audio .video .image .pdf .docx .txt" : "Upload your file"}
                                                    </span>
                                                </>
                                            }
                                            {!!fileUploadError && <span className='h6-medium color-primary-danger'>{fileUploadError}</span>}
                                            {!!fileUpload &&
                                                <div className={`h5-regular ${!fileUploadError ? "bg-color-secondary" : "bg-color-photosensitivity-warning"} d-flex justify-center align-center mt-1  br-2 w-p-90`}>
                                                    <div className="m-1 w-p-7 d-flex justify-center align-center">
                                                        <DisplayMediaIcon FileName={fileUpload?.name} />
                                                    </div>
                                                    <span className={`d-flex w-p-75 h6-regular`}>
                                                        {fileUpload?.name}
                                                        <span className='ml-3'>{formatFileSize(fileUpload?.size)}</span>
                                                    </span>
                                                    <div className="d-flex justify-center align-center w-p-18">
                                                        {documnetPermisson === DocumentPermissions.READONLY ? <ReadOnlyIcon className='mr-2' /> : <SecureFileDownloadIcon className='mr-2' />}
                                                        <CancelIcon onClick={handleCancel} className="c-pointer" />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {selectedTab === "upload" && selectedAuth === "email" && (
                            <div className={`${IsMobileDevice ? "mx-1" : "mx-2"}`}>
                                <div className="d-flex w-p-100 align-center justify-between mx-auto">
                                    <div className={`${IsMobileDevice ? "w-p-25" : "w-p-30"} my-1`}>
                                        <div className="h5-semibold">File Name</div>
                                        <TextField
                                            size='small'
                                            fullWidth
                                            variant="outlined"
                                            className='mt-1'
                                            disabled
                                            placeholder='Default File name'
                                            value={fileUpload?.name || ""}
                                            InputProps={{ classes: { input: `h4-regular` } }}
                                        />
                                    </div>
                                    <div className={`${IsMobileDevice ? "w-p-35" : "w-p-32"} my-1`}>
                                        <div className="h5-semibold mb-1">Validity Period</div>
                                        <Autocomplete
                                            size="small"
                                            classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                            options={ValidityPeriod}
                                            getOptionLabel={(option) => option?.Name}
                                            onChange={handlValidityPeriod}
                                            value={ValidityPeriod.find(x => x.Value === Number(isValidityPeriod))}
                                            renderOption={(defaultprops, option, { selected }) => (
                                                <li {...defaultprops} className={`${defaultprops.className} c-pointer h4-regular ${IsDarkMode ? "" : "color-primary-dark"} p-1 ml-1 d-flex justify-between ${selected ? 'Mui-focused' : ''}`}>
                                                    {option?.Name}
                                                </li>
                                            )}
                                            renderInput={(params) => <TextField {...params} name="validity period" placeholder="select" required variant="outlined" />}
                                        />
                                    </div>
                                    <div className="w-p-33">
                                        <div className="h5-semibold mb-1">{`${IsMobileDevice ? "" : "Document"} Permissions`}</div>
                                        <Select
                                            size='small'
                                            value={documnetPermisson || ""}
                                            onChange={(event) => handleDocumentPermissions(event.target.value)}
                                            renderValue={(selected) => {
                                                const selectedOption = documentPermissions.find((x) => x.Value === selected);
                                                return (
                                                    <div className="d-flex o-hidden" >
                                                        <div className="mr-1 d-flex align-center">{selectedOption.Icon}</div>
                                                        <span className="o-hidden t-overflow-ellipsis">{selectedOption.Name}</span>
                                                    </div>
                                                )
                                            }}
                                            sx={{
                                                width: "100%",
                                                "& .MuiSelect-select": {
                                                    overflow: "hidden"
                                                }
                                            }}
                                        >
                                            {documentPermissions.map((option) => (
                                                <MenuItem key={option.Value} value={option.Value}>
                                                    <div className="d-flex">
                                                        <div className="mr-1 d-flex align-center">{option.Icon}</div>
                                                        <span>{option.Name}</span>
                                                    </div>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </div>
                                </div>
                                <div className="d-flex w-p-100">
                                    <div className="flex-direction w-p-97 ml-1 mt-2">
                                        <div className="h5-semibold">Share With</div>
                                        <span className=''>
                                            <AddAccessListTextComponent
                                                PlaceHolder={"People with access: "}
                                                AddAccessListHandel={addAccessListHandel}
                                            />
                                        </span >
                                    </div>
                                </div>
                                <div className='bg-color-conv-hist-bg h-20 d-flex align-center justify-center br-2 mt-1'>
                                    <div
                                        onClick={() => {
                                            if (!fileUpload) {
                                                fileInputRef.current?.click();
                                            }
                                        }}
                                        className={`d-flex  flex-direction align-center justify-center ${!fileUpload && "c-pointer"} ${(!!fileUpload && !fileUploadError) ? '' : `bg-color-secondary  m-2 h-p-80 ${!!fileUploadError ? "b-around-danger" : "import-contacts-border"}`}  br-2 w-p-100 `}>
                                        {!fileUpload &&
                                            <>
                                                <UploadFileIcon />
                                                <input
                                                    id="Upload"
                                                    type="file"
                                                    name='fileupload'
                                                    className="p-absolute t-0 l-0 opacity-0 c-pointer"
                                                    ref={fileInputRef}
                                                    onChange={onChange}
                                                    accept={documnetPermisson === DocumentPermissions.READONLY ? "audio/*,video/*,image/*,.pdf,.docx,.txt" : ""}
                                                />
                                                <span className={`h5-regular ${IsDarkMode ? "" : "color-disabled-bt"}n d-flex align-center justify-center`}>
                                                    {documnetPermisson === DocumentPermissions.READONLY ? "Upload your file .audio .video .image .pdf .docx .txt" : "Upload your file"}
                                                </span>
                                            </>
                                        }
                                        {!!fileUploadError && <span className='h6-medium color-primary-danger'>{fileUploadError}</span>}
                                        {!!fileUpload &&
                                            <div className={`h5-regular ${!fileUploadError ? "bg-color-secondary" : "bg-color-photosensitivity-warning"} d-flex justify-center align-center mt-1  br-2 w-p-90`}>
                                                <div className="m-1 w-p-7 d-flex justify-center align-center">
                                                    <DisplayMediaIcon FileName={fileUpload?.name} />
                                                </div>
                                                <span className={`d-flex w-p-75 h6-regular`}>
                                                    {fileUpload?.name}
                                                    <span className='ml-3'>{formatFileSize(fileUpload?.size)}</span>
                                                </span>
                                                <div className="d-flex justify-center align-center w-p-18">
                                                    {documnetPermisson === DocumentPermissions.READONLY ? <ReadOnlyIcon className='mr-2' /> : <SecureFileDownloadIcon className='mr-2' />}
                                                    <CancelIcon onClick={handleCancel} className="c-pointer" />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                        {selectedTab === "library" && selectedAuth === "face" && (
                            <div className={`h-v-40 d-flex flex-direction  justify-between`}>
                                {!PlanMetrics?.HasAccessToFaceVault ?
                                    <div className="d-flex justify-center align-center flex-direction">
                                        <div className="d-flex justify-center align-center"><UpgradeFeatureIcon className="w-p-65 h-24" /></div>
                                        <div className="h4-semibold mt-1 color-settings-heading">Upgrade your plan for more features.</div>
                                        <div className='d-flex mt-1'>
                                            <div className='h5-regular t-align-center color-settings-heading'>or connect us for</div>&nbsp;&nbsp;
                                            <div className='h5-regular t-align-center color-login-link c-pointer'>
                                                <Link tabIndex={5}
                                                    data-arrow-index={10}
                                                    data-up-arrow-index={6}
                                                    data-down-arrow-index={7}
                                                    data-left-arrow-index={2}
                                                    data-right-arrow-index={10}
                                                    to={null}>
                                                    Customer support
                                                </Link>
                                            </div>
                                        </div>
                                        <ButtonComponent OnClick={() => navigate(AppRoutes.PLANS)} ButtonLabel={buttonLabels.UPGRADE_NOW} ClassName={"mt-2"} Variant={"primary-btn-small"} />
                                    </div>
                                    :
                                    <GridComponent
                                        ColumnDefs={FileLibraryFaceColumnDefs}
                                        RowData={SecureFiles.filter(x => x.Status === SecureFileStatusModel.Active)}
                                        OnGridReady={onGridReady}
                                        IsPaginationEnabled={false}
                                        OnGridRowClick={(e) => {
                                            props.CloseSecurefilePopover(e.FaceShortUrl);
                                        }}
                                        EmptyLabel={emptyLabels.SECURE_FILES}
                                        IsFilterPresent={false}
                                        LockVisible={false}
                                    />}
                            </div>
                        )}
                        {selectedTab === "library" && selectedAuth === "email" && (
                            <div className={`d-flex flex-direction justify-between h-v-40`}>
                                <GridComponent
                                    ColumnDefs={FileLibraryEmailColumnDefs}
                                    RowData={SecureFiles?.filter(x => x.Status === SecureFileStatusModel.Active)}
                                    OnGridReady={onGridReady}
                                    IsPaginationEnabled={false}
                                    OnGridRowClick={(e) => {
                                        props.CloseSecurefilePopover(e.EmailShortUrl);
                                    }}
                                    EmptyLabel={emptyLabels.SECURE_FILES}
                                    IsFilterPresent={false}
                                    LockVisible={false}
                                />
                            </div>
                        )}
                    </div>
                </div>

                <DialogActions className='pr-0 mt-1'>
                    <ButtonComponent
                        ClassName='mr-1'
                        OnClick={closeCustomField}
                        Variant={"secondary-btn-small"}
                        ButtonLabel={buttonLabels.CANCEL}
                    />
                    {selectedTab === "upload" && (selectedAuth === "face" ? (props.Limit === 1 ? faceRegistrationStatus === FaceRegistrationInviteLinkStatus.Registered || faceRegistrationStatus === FaceRegistrationInviteLinkStatus.Pending : true) : true) &&
                        <ButtonComponent
                            Loading={isLoaded}
                            ButtonLabel={buttonLabels.UPLOAD_SHARE}
                            Variant={(!!fileUpload && !fileUploadError && isVaild()) ? 'primary-btn-small' : 'disabled-btn-small'}
                            OnClick={selectedAuth === "face" || "email" ? formSubmit : () => { }}
                        />
                    }
                </DialogActions>
            </DialogContent>
        </>
    )
}
export default SecureFilePopoverComponent